import { enableProdMode, importProvidersFrom } from '@angular/core';
import { platformBrowser, BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import 'zone.js';


import { environment } from './environments/environment';
import { BulletinService } from './app/features/servicebulletin/bulletin.service';
import { TechTrainingManualService } from './app/features/tech-training-manual/tech-training-manual.service';
import { SpinnerService } from './app/core/services/spinner/spinner.service';
import { SearchResultsService } from './app/features/search-results/search-results.service';
import { BodyPaintManualService } from './app/features/body-and-paint-manual/body-paint-manual.service';
import { UtilityService } from './app/core/services/utility/utility.service';
import { PagerService } from './app/features/pagination/pager.service';
import { VideosService } from './app/features/videos/videos.service';
import { DialogService } from './app/core/services/dialog/dialog.service';
import { TechnicalDocumentationService } from './app/features/technical-documentation/technical-documentation.service';
import { LegacyService } from './app/features/legacy/legacy.service';
import { TriBulletinService } from './app/features/tri-bulletins-home/tri-bulletin.service';
import { TakataRecallService } from './app/features/takata-recall/takata-recall.service';
import { PartsBulletinsService } from './app/features/parts-bulletins/parts-bulletins.service';
import { OperatingFluidsService } from './app/features/operating-fluids/operating-fluids.service';
import { OnboardDiagnosticService } from './app/features/onboard-diagnostic/onboard-diagnostic.service';
import { UserProfileService } from './app/features/user-profile/user-profile.service';
import { FaqAndTopLinksService } from './app/features/faq-and-top-links/faq-and-top-links.service';
import { ToolsAndEquipmentManualsService } from './app/features/tool-report/tools-and-equipment-manuals.service';
import { ModelMapService } from './app/features/model-map/model-map.service';
import { CmsNavbarService } from './app/features/cms-navbar/cms-navbar.service';
import { AdminService } from './app/features/admin/admin.service';
import { AuthService } from '@services';
import { AuthGuard, SaveChangesGuard, RoleAuthGuard } from '@guards';
import { Routes, withHashLocation, provideRouter } from '@angular/router';
import { HomeComponent } from './app/features/home/home.component';
import { AccessdeniedComponent } from './app/features/accessdenied/accessdenied.component';
import { LogoutComponent } from './app/features/logout/logout.component';
import { TechTrainingManualComponent } from './app/features/tech-training-manual/tech-training-manual.component';
import { BodyAndPaintManualComponent } from './app/features/body-and-paint-manual/body-and-paint-manual.component';
import { VideosComponent } from './app/features/videos/videos.component';
import { VideosHomeComponent } from './app/features/videos/videos-home/videos-home.component';
import { VideosSubscriptionComponent } from './app/features/videos/videos-subscription/videos-subscription.component';
import { VideosWatchlistComponent } from './app/features/videos/videos-watchlist/videos-watchlist.component';
import { VideosHistoryComponent } from './app/features/videos/videos-history/videos-history.component';
import { VideosChannelsComponent } from './app/features/videos/videos-channels/videos-channels.component';
import { VideosManageSubscriptionComponent } from './app/features/videos/videos-manage-subscription/videos-manage-subscription.component';
import { VideosChannelInfoComponent } from './app/features/videos/videos-channel-info/videos-channel-info.component';
import { VideosPlaybackComponent } from './app/features/videos/videos-playback/videos-playback.component';
import { NoiseCatalogComponent } from './app/features/noise-catalog/noise-catalog.component';
import { NoiseCatalogHomeComponent } from './app/features/noise-catalog/noise-catalog-home/noise-catalog-home.component';
import { NoiseCatalogWatchlistComponent } from './app/features/noise-catalog/noise-catalog-watchlist/noise-catalog-watchlist.component';
import { NoiseCatalogHistoryComponent } from './app/features/noise-catalog/noise-catalog-history/noise-catalog-history.component';
import { NoiseCatalogPlaybackComponent } from './app/features/noise-catalog/noise-catalog-playback/noise-catalog-playback.component';
import { ScopePatternComponent } from './app/features/scope-pattern/scope-pattern.component';
import { ScopePatternHomeComponent } from './app/features/scope-pattern/scope-pattern-home/scope-pattern-home.component';
import { TisSupportComponent } from './app/features/tis-support/tis-support.component';
import { BulletinDetailComponent } from './app/features/bulletin-detail/bulletin-detail.component';
import { SearchResultsComponent } from './app/features/search-results/search-results.component';
import { TechnicalDocumentationComponent } from './app/features/technical-documentation/technical-documentation.component';
import { LegacyComponent } from './app/features/legacy/legacy.component';
import { ServiceBulletinHomeComponent } from './app/features/service-bulletin-home/service-bulletin-home.component';
import { TriBulletinsHomeComponent } from './app/features/tri-bulletins-home/tri-bulletins-home.component';
import { TakataRecallComponent } from './app/features/takata-recall/takata-recall.component';
import { PartsBulletinsComponent } from './app/features/parts-bulletins/parts-bulletins.component';
import { OperatingFluidsComponent } from './app/features/operating-fluids/operating-fluids.component';
import { OnboardDiagnosticComponent } from './app/features/onboard-diagnostic/onboard-diagnostic.component';
import { EquipmentManualsComponent } from './app/features/equipment-manuals/equipment-manuals.component';
import { SignupComponent } from './app/features/signup/signup.component';
import { ResetPasswordComponent } from './app/features/reset-password/reset-password.component';
import { ToolReportContentComponent } from './app/features/tool-report/tool-report-content/tool-report-content.component';
import { UserProfileComponent } from './app/features/user-profile/user-profile.component';
import { UserProfileManagerComponent } from './app/features/user-profile/user-profile-manager/user-profile-manager.component';
import { FaqAndTopLinksComponent } from './app/features/faq-and-top-links/faq-and-top-links.component';
import { UserLoginComponent } from './app/features/user-login/user-login.component';
import { ModelMapComponent } from './app/features/model-map/model-map.component';
import { PaypalLoginComponent } from './app/features/paypal-login/paypal-login.component';
import { AddNewBulletinComponent } from './app/features/admin/add-new-bulletin/add-new-bulletin.component';
import { ShowMessagesComponent } from './app/features/admin/show-messages/show-messages.component';
import { AddBulletinForVideoToolObdComponent } from './app/features/admin/add-bulletin-for-video-tool-obd/add-bulletin-for-video-tool-obd.component';
import { AddBulletinForNoiseCatalogComponent } from './app/features/admin/add-bulletin-for-noise-catalog/add-bulletin-for-noise-catalog.component';
import { AddBulletinForScopePatternComponent } from './app/features/admin/add-bulletin-for-scope-pattern/add-bulletin-for-scope-pattern.component';
import { EditBulletinForNoiseCatalogComponentComponent } from './app/features/admin/edit-bulletin-for-noise-catalog-component/edit-bulletin-for-noise-catalog-component.component';
import { EditBulletinForScopePatternComponentComponent } from './app/features/admin/edit-bulletin-for-scope-pattern-component/edit-bulletin-for-scope-pattern-component.component';
import { AddBulletinInfoComponent } from './app/features/admin/add-bulletin-info/add-bulletin-info.component';
import { MessagesComponent } from './app/features/admin/messages/messages.component';
import { ShowUsersComponent } from './app/features/admin/show-users/show-users.component';
import { ShowBulletinFullReportComponent } from './app/features/admin/show-bulletin-full-report/show-bulletin-full-report.component';
import { ShowBulletinAvgReportComponent } from './app/features/admin/show-bulletin-avg-report/show-bulletin-avg-report.component';
import { ManageUserComponent } from './app/features/admin/manage-user/manage-user.component';
import { ToolReportDetailComponent } from './app/features/tool-report/tool-report-detail/tool-report-detail.component';
import { OssComponent } from './app/features/oss/oss.component';
import { DisclaimerComponent } from './app/features/disclaimer/disclaimer.component';
import { ToastConfigService } from './app/core/services/toast-config/toast-config.service';
import { TisSupportService } from './app/features/tis-support/tis-support.service';
import { SharedService } from './app/features/share-content/shared.service';
import { PaypalService } from './app/features/paypal-login/paypal.service';
import { NoiseCatalogService } from './app/features/noise-catalog/noise-catalog.service';
import { ScopePatternService } from './app/features/scope-pattern/scope-pattern.service';
import { CookieService } from './app/core/services/cookie/cookie-service.service';
import { AnalyticsService } from './app/core/services/analytics/analytics.service';
import { ScriptInjectorService } from './app/core/services/analytics/script-injector.service';
import { interceptorProviders } from './app/core/interceptors/interceptors';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { DatePipe, CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import 'froala-editor/js/plugins.pkgd.min.js';
import { NgxPaginationModule } from 'ngx-pagination';
import { IMaskModule } from 'angular-imask';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ToastrModule } from 'ngx-toastr';
import { AppComponent } from './app/app.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/home', pathMatch: 'full'
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'accessdenied',
    component: AccessdeniedComponent,
  },
  {
    path: 'logout',
    component: LogoutComponent
  },
  {
    path: 'tech-training-manual',
    component: TechTrainingManualComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'body-paint-manual',
    component: BodyAndPaintManualComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'videos',
    component: VideosComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: 'home', component: VideosHomeComponent },
      { path: 'subscription', component: VideosSubscriptionComponent },
      { path: 'watchlist', component: VideosWatchlistComponent, canDeactivate: [SaveChangesGuard] },
      { path: 'history', component: VideosHistoryComponent },
      { path: 'channels', component: VideosChannelsComponent, canDeactivate: [SaveChangesGuard] },
      { path: 'manage-subscription', component: VideosManageSubscriptionComponent },
      { path: 'channel-info/:id', component: VideosChannelInfoComponent }
    ]
  },
  {
    path: 'home/videos',
    redirectTo: 'videos'
  },
  {
    path: 'playback',
    component: VideosPlaybackComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'noise-catalog',
    component: NoiseCatalogComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: 'home', component: NoiseCatalogHomeComponent },
      { path: 'watchlist', component: NoiseCatalogWatchlistComponent, canDeactivate: [SaveChangesGuard] },
      { path: 'history', component: NoiseCatalogHistoryComponent },
    ]
  },
  {
    path: 'home/noise-catalog',
    redirectTo: 'noise-catalog'
  },
  {
    path: 'noisecatalogplayback',
    component: NoiseCatalogPlaybackComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'scope-pattern',
    component: ScopePatternComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: 'home', component: ScopePatternHomeComponent },
    ]
  },
  {
    path: 'home/scope-pattern',
    redirectTo: 'scope-pattern'
  },
  {
    path: 'tis-support',
    component: TisSupportComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'bulletin/:id',
    component: BulletinDetailComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'results/:section',
    component: SearchResultsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'tech-doc',
    component: TechnicalDocumentationComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'legacy',
    component: LegacyComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'sib-home',
    component: ServiceBulletinHomeComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'tri-home',
    component: TriBulletinsHomeComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'takata-recall',
    component: TakataRecallComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'parts-home',
    component: PartsBulletinsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'operating-fluid',
    component: OperatingFluidsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'obd',
    component: OnboardDiagnosticComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'home/obd',
    redirectTo: 'obd'
  },
  {
    path: 'equip-manual',
    component: EquipmentManualsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'signup',
    component: SignupComponent
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'home/equip-manual',
    redirectTo: 'equip-manual'
  },
  {
    path: 'tool-report',
    component: ToolReportContentComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'home/tool-report',
    redirectTo: 'tool-report'
  },
  {
    path: 'profile',
    component: UserProfileComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'manage-profile/:section',
    component: UserProfileManagerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'faq',
    component: FaqAndTopLinksComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'login',
    component: UserLoginComponent
  },
  {
    path: 'model-map',
    component: ModelMapComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'paypal-login',
    component: PaypalLoginComponent,
  },
  {
    path: 'add-bulletin',
    component: AddNewBulletinComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'show-messages',
    component: ShowMessagesComponent
  },
  {
    path: 'add-video-tool-obd/:bulletinType/:actionType',
    component: AddBulletinForVideoToolObdComponent,
    canActivate: [AuthGuard]
  },
  {
    //add-bulletin-for-noise-catalog
    path: 'add-noise-catalog/:bulletinType/:actionType',
    component: AddBulletinForNoiseCatalogComponent,
    canActivate: [AuthGuard]
  },
  {
    //add-bulletin-for-scope-pattern
    path: 'add-scope-pattern/:bulletinType/:actionType',
    component: AddBulletinForScopePatternComponent,
    canActivate: [AuthGuard]
  },
  {
    //edit-bulletin-for-noise-catalog
    path: 'edit-noise-catalog/:bulletinType/:actionType',
    component: EditBulletinForNoiseCatalogComponentComponent,
    canActivate: [AuthGuard]
  },
  {
    //edit-bulletin-for-scope-pattern
    path: 'edit-scope-pattern/:bulletinType/:actionType',
    component: EditBulletinForScopePatternComponentComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'add-bulletin-info',
    component: AddBulletinInfoComponent,
    canActivate: [AuthGuard]
    // canActivate: [AuthGuard, RoleAuthGuard]
  },
  {
    path: 'add-message',
    component: MessagesComponent
  },
  {
    path: 'show-users',
    component: ShowUsersComponent
  },
  {
    path: 'show-bulletin-full-report',
    component: ShowBulletinFullReportComponent
  },
  {
    path: 'show-bulletin-avg-report',
    component: ShowBulletinAvgReportComponent
  },
  {
    path: 'manage-user/:action',
    component: ManageUserComponent
  },
  {
    path: 'report-detail/:id',
    component: ToolReportDetailComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'oss',
    component: OssComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'disclaimer',
    component: DisclaimerComponent,
    canActivate: [AuthGuard]
  },
  { path: '**', redirectTo: '/home', pathMatch: 'full' }
];



if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule, CommonModule, FormsModule, FontAwesomeModule, ReactiveFormsModule, FroalaEditorModule.forRoot(), FroalaViewModule.forRoot(), NgxPaginationModule, IMaskModule, NgMultiSelectDropDownModule.forRoot(), ToastrModule.forRoot({
            closeButton: true,
            tapToDismiss: true,
            preventDuplicates: true,
            positionClass: 'toast-bottom-center',
            timeOut: 2000
        })),
        BulletinService,
        TechTrainingManualService,
        SpinnerService,
        SearchResultsService,
        BodyPaintManualService,
        UtilityService,
        PagerService,
        VideosService,
        DialogService,
        TechnicalDocumentationService,
        LegacyService,
        TriBulletinService,
        TakataRecallService,
        PartsBulletinsService,
        OperatingFluidsService,
        OnboardDiagnosticService,
        UserProfileService,
        FaqAndTopLinksService,
        ToolsAndEquipmentManualsService,
        ModelMapService,
        CmsNavbarService,
        AdminService,
        AuthService,
        AuthGuard,
        RoleAuthGuard,
        SaveChangesGuard,
        ToastConfigService,
        TisSupportService,
        SharedService,
        PaypalService,
        NoiseCatalogService,
        ScopePatternService,
        CookieService,
        AnalyticsService,
        ScriptInjectorService,
        interceptorProviders,
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations(),
        DatePipe,
        provideRouter(routes, withHashLocation())
    ]
})
  .catch(err => console.log(err));
